<template>
    <div id="content">
        <router-link :to="$route.path.split('/').slice(0, -1).join('/')" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('modules.new.back') }}</router-link>
        <div class="admin-card edit-card">
            <div class="admin-section-label">
                <i class="bi bi-plus-square"></i>
                {{ $t('modules.new.title') }}
            </div>
            <form action="/api/modules/new" method="post" @submit.prevent="createModule">
                <div class="form-grid">
                    <div class="form-row">
                        <label for="moduleTitle" class="form-label">{{ $t('modules.new.form.name') }}</label>
                        <input type="text" class="form-control" name="moduleTitle" v-model="title" id="moduleTitle" :placeholder="$t('modules.new.form.name')" required>
                    </div>
                    <div class="form-row">
                        <label for="moduleDescription" class="form-label">{{ $t('modules.new.form.description') }}</label>
                        <input type="text" class="form-control" name="moduleDescription" v-model="description" id="moduleDescription" :placeholder="$t('modules.new.form.description')" required>
                    </div>
                    <div class="form-row">
                        <label for="moduleSlug" class="form-label">{{ $t('modules.new.form.slug') }}</label>
                        <input type="text" class="form-control" name="moduleSlug" v-model="slug" id="moduleSlug" :placeholder="`${$t('modules.new.form.slugPlaceholder')}${defaultSlug}`">
                    </div>
                </div>

                <div class="functions-section">
                    <div class="admin-section-label">
                        <i class="bi bi-list-check"></i>
                        {{ $t('modules.new.functions.title') }}
                    </div>
                    <div v-for="(f, i) in functions" :key="i" class="function-card" :id="'functionInput'+(i+1)">
                        <div class="function-card-header">
                            <span class="function-card-index">#{{ i + 1 }}</span>
                            <button v-if="functions.length > 1" type="button" class="function-card-remove" @click="removeFunction(i)" :title="$t('modules.new.functions.remove')">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label :for="'function'+(i+1)" class="form-label">{{ $t('modules.new.functions.name') }}</label>
                                <input type="text" class="form-control" v-model="f.title" @change="f.slug = strToLat(f.title)" :name="'function'+(i+1)" :id="'function'+(i+1)" required>
                            </div>
                            <div class="col-md-6">
                                <label :for="'functionSelect'+(i+1)" class="form-label">{{ $t('modules.new.functions.type') }}</label>
                                <select class="form-select" v-model="f.type" :name="'functionSelect'+(i+1)" :id="'functionSelect'+(i+1)" required>
                                    <option v-for="type in types" :value="type.value">{{ type.text }}</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label :for="'functionDesc'+(i+1)" class="form-label">{{ $t('modules.new.functions.description') }}</label>
                                <input type="text" class="form-control" v-model="f.description" :name="'functionDesc'+(i+1)" :id="'functionDesc'+(i+1)" required>
                            </div>
                            <div class="col-md-6">
                                <label :for="'functionSlug'+(i+1)" class="form-label">{{ $t('modules.new.functions.slug') }}</label>
                                <input type="text" class="form-control" v-model="f.slug" :name="'functionSlug'+(i+1)" :id="'functionSlug'+(i+1)">
                            </div>
                        </div>
                    </div>
                    <div class="text-center mt-3">
                        <button v-if="functions.length < 30" type="button" class="btn-add-function" @click="addFunction">
                            <i class="bi bi-plus-lg"></i>
                            <span>{{ $t('modules.new.functions.add') }}</span>
                        </button>
                    </div>
                </div>

                <div class="form-actions">
                    <button type="submit" class="btn-purple">
                        <i class="bi bi-check2"></i>
                        <span>{{ $t('modules.new.actions.create') }}</span>
                    </button>
                    <button type="button" class="btn-ghost" @click="cancel">{{ $t('modules.new.actions.cancel') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import cyrillicToTranslit from 'cyrillic-to-translit-js'

export default {
    data:() => ({
        title: '',
        description: '',
        slug: '',
        functions: [{
            title: '',
            type: 'number',
            description: '',
            slug: ''
        }]
    }),
    mounted() {
        this.$emit('setPageTitle', this.$t('modules.new.title'))
    },
    computed: {
        types() {
            return [
                { text: this.$t('modules.new.functions.typeOptions.number'), value: 'number' },
                { text: this.$t('modules.new.functions.typeOptions.switch'), value: 'switch' },
                { text: this.$t('modules.new.functions.typeOptions.checkNumber'), value: 'check-number' },
                { text: this.$t('modules.new.functions.typeOptions.checkGroup'), value: 'check-group' }
            ]
        },
        defaultSlug() {
            if(!this.title) return ''
            return this.$t('modules.new.form.slugDefault', { value: this.strToLat(this.title) })
        }
    },
    methods: {
        async createModule() {
            let data = { title: this.title, description: this.description, functions: this.functions, slug: this.slug}
            let response = await this.$api.createModule(data)
            if(response.result === 'SUCCESS') this.$router.push('/modules')
        },
        addFunction() {
            if(this.functions.length >= 30) return false
            this.functions.push({ title: '', type: 'number', description: ''})
        },
        removeFunction(index) {
            if(this.functions.length <= 1) return false
            this.functions.splice(index, 1)
        },
        cancel() {
            this.$router.go(-1)
        },
        strToLat(text) {
            if(!text) return ''

            return new cyrillicToTranslit().transform(text, '_').toLowerCase()
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.edit-card {
    padding: 24px;
    max-width: 900px;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: 160px 1fr;
    align-items: center;
    gap: 16px;
}

.form-row .form-label {
    margin-bottom: 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
}

.functions-section {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #e5e7eb;
}

.function-card {
    background: #fafbfc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px 18px;
    margin-bottom: 12px;
}

.function-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.function-card-index {
    font-size: 12px;
    font-weight: 600;
    color: #7c3aed;
    background: #ede9fe;
    padding: 3px 10px;
    border-radius: 999px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.function-card-remove {
    background: transparent;
    border: 1px solid #fecaca;
    color: #991b1b;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.15s ease;
}
.function-card-remove:hover {
    background: #fee2e2;
}

.btn-add-function {
    background: transparent;
    border: 1.5px dashed #cbd5e1;
    color: #64748b;
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.15s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.btn-add-function:hover {
    border-color: #c4b5fd;
    background: #faf7ff;
    color: #6d28d9;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #e5e7eb;
    flex-wrap: wrap;
}
</style>
